export default "__VITE_ASSET__CFMIahy1__"